export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7641.1822f5fb.jpg";